<template>
  <nav-bar
    title="用户"
    :hasBack="stId !== $store.state.roleInfo.companyId"
    :back="goBack"
  />
  <layout-supervise :top="48">
    <Loading
      v-if="showLoading"
      :isLoading="isLoading"
      @reload="getDataLoading(stId)"
    />
    <div class="total-info">
      <span>区域名称：{{ objData.stName }}</span>
      <span>用户总数：{{ objData.allNum }}</span>
    </div>
    <div class="total-info">
      <span>合法用户数：{{ objData.legalNum }}</span>
      <span>非法用户数：{{ objData.noLegalNum }}</span>
    </div>
    <ul class="list">
      <li class="list-item" v-for="item in list" :key="item.regionCode">
        <span>{{ item.regionName }}:</span>
        <span
          class="item-link"
          :style="{ 'text-decoration': item.reNum > 0 ? 'underline' : '' }"
          @click="handleNumClick(item)"
        >
          {{ item.reNum }}
        </span>
        <span>合法：{{ item.legalNum }}</span>
        <span>非法：{{ item.noLegalNum }}</span>
      </li>
    </ul>
  </layout-supervise>
</template>

<script>
import { useGetDataLoading } from '@/hooks/useGetDataLoading'
import { StatisticsCustomerByRegion } from '@/api/superviseHome'
import { useStore } from 'vuex'
import { computed, ref } from 'vue'
import { useRouter } from 'vue-router'
export default {
  name: 'SuperviseUser',
  setup() {
    const router = useRouter()
    const objData = ref({})
    const list = ref([])
    const store = useStore()
    const stId = ref('')
    const companyId = computed(() => store.state.roleInfo.companyId)
    const streetLevel = computed(() => store.state.roleInfo.streetLevel)
    const streetName = computed(() => store.state.roleInfo.streetName)
    const tenantId = computed(() => store.state.roleInfo.tenantId)
    stId.value = companyId.value
    const { getDataLoading, showLoading, isLoading } = useGetDataLoading(
      StatisticsCustomerByRegion,
      data => {
        objData.value = data
        list.value = data.infoList
      }
    )
    if (streetLevel.value >= 4) {
      router.push(`/superviseUserList/${streetName.value}/${companyId.value}`)
    } else {
      getDataLoading({ stId: stId.value, tenantId: tenantId.value || '' })
    }

    const handleNumClick = ({ level, regionCode, regionName }) => {
      if (level < 4) {
        stId.value = regionCode
        getDataLoading({ stId: stId.value, tenantId: tenantId.value || '' })
      } else {
        router.push(`/superviseUserList/${regionName}/${regionCode}`)
      }
    }
    const goBack = () => {
      stId.value = companyId.value
      getDataLoading({ stId: stId.value, tenantId: tenantId.value || '' })
    }
    return {
      getDataLoading,
      showLoading,
      isLoading,
      objData,
      list,
      stId,
      handleNumClick,
      goBack,
      tenantId
    }
  }
}
</script>

<style lang="scss" scoped>
.total-info {
  padding: 16px;
  font-size: 16px;
  display: flex;
  justify-content: space-between;
  font-weight: 600;
}
.list {
  padding: 0 16px;
  .list-item {
    background: #fff;
    font-size: 16px;
    padding: 10px 5px;
    margin-bottom: 10px;
    span:first-child {
      margin-right: 0;
     }
     span:nth-child(2) {
      font-size: 14px;
     }
    span {
      margin-right: 10px;
      font-size: 12px;
    }
    .item-link {
      color: blue;
      padding-left: 10px;
    }
  }
}
</style>
